import { render, staticRenderFns } from "./FilesList.vue?vue&type=template&id=4944c9f2"
import script from "./FilesList.vue?vue&type=script&lang=js"
export * from "./FilesList.vue?vue&type=script&lang=js"
import style0 from "./FilesList.vue?vue&type=style&index=0&id=4944c9f2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports